export interface DebugState {
  visible: boolean;
  elements: DebugElement[];
  logEnabledElements: string[];
}

export interface DebugElement {
  name: string;
  calls: DebugMethodCall[];
  counts: Record<number, number>;
}

export interface DebugMethodCall {
  second: number;
  method: string;
  source: any;
}

export class DebugService {
  private visible: boolean = false;
  private elements: DebugElement[] = [];
  private logEnabledElements: string[] = [];

  public report(source: any, method: string) {
    // const sourceName = source.constructor.name.substring(1);
    // const now = new Date();
    // const nowSeconds = Math.floor(now.getTime() / 1000);
    //
    // // Find or create the correct element for the given type and method
    // const name = sourceName;
    // let element = this.elements.find(e => e.name === name);
    // if (!element) {
    //   element = { name, calls: [], counts: [] };
    //   this.elements.push(element);
    //   this.elements.sort((a, b) => a.name.localeCompare(b.name));
    // }
    //
    // // Add call
    // element.calls.push({
    //   second: nowSeconds,
    //   method,
    //   source,
    // });
    //
    // // Update counts
    // const existingCount = element.counts[nowSeconds] || 0;
    // element.counts[nowSeconds] = existingCount + 1;
    //
    // // Maybe log
    // if (this.logEnabledElements.includes(name) && method.includes('update')) {
    //   console.warn('[DebugService]', name, ':', method, source?.state);
    // }
    //
    // // Perform cleanup of old elements
    // this.cleanUp();
  }

  private cleanUp() {
    const oneMinuteAgo = Math.floor(new Date().getTime() / 1000) - 60;

    this.elements = this.elements
      .map(element => {
        const calls = element.calls.filter(call => Number(call.second) >= oneMinuteAgo);
        for (const timestamp in element.counts) {
          if (Number(timestamp) < oneMinuteAgo) {
            delete element.counts[timestamp];
          }
        }
        return {
          ...element,
          calls,
        };
      })
      .filter(entry => entry.calls.length > 0);
  }

  public clear() {
    this.elements = [];
    this.logEnabledElements = [];
  }

  public toggleLogging(elementName: string) {
    const index = this.logEnabledElements.indexOf(elementName);
    if (index === -1) {
      this.logEnabledElements.push(elementName);
    } else {
      this.logEnabledElements.splice(index, 1);
    }
  }

  public toggleVisible() {
    this.visible = !this.visible;
  }

  public get state(): DebugState {
    return {
      visible: this.visible,
      elements: this.elements,
      logEnabledElements: this.logEnabledElements,
    };
  }
}
